import React, { useState } from "react";
import "./qualification.css";

const Qualification = () => {
  const [tab, setTab] = useState("education");
  const [selectedRole, setSelectedRole] = useState(null);

  /* ---- DATA STRUCTURE ---- */
  const education = [
    {
      key: "msc",
      category: "education",
      title: "MSc. (Artificial Intelligence and Human Factors)",
      place: "Coventry University",
      duration: "2024 – 2025",
      description: [
        "Gained expertise in AI systems and user-centered design.",
        "Completed thesis on empathetic health chatbots using LLMs.",
        "Worked with Python, TensorFlow, LangChain."
      ]
    },
    {
      key: "bsc",
      category: "education",
      title: "BSc. (Hons) Computer Science",
      place: "University of Wolverhampton",
      duration: "2019 – 2022",
      description: [
        "Studied algorithms, operating systems, databases.",
        "Projects using JavaScript, React, MySQL.",
        "Graduated with distinction."
      ]
    }
  ];

  const experience = [
    {
      key: "itd",
      category: "experience",
      title: "Information Technology Assistant",
      place: "The Nepal Distilleries PVT.LTD",
      duration: "Jul 2020 – Oct 2020",
      description: [
        "Provided IT support for daily factory operations.",
        "Maintained computers, printers, and networks.",
        "Supported ERP upgrades and system monitoring."
      ]
    },
    {
      key: "thi",
      category: "experience",
      title: "Software Engineer",
      place: "The High Innovations",
      duration: "Feb 2021 – Dec 2023",
      description: [
        "Built enterprise software solutions.",
        "Led team in microservices migration.",
        "Integrated APIs & CI/CD pipelines."
      ]
    },
    {
      key: "ct",
      category: "experience",
      title: "Software Engineer",
      place: "Code Tara Pvt Ltd",
      duration: "Jan 2024 – Jun 2024",
      description: [
        "Developed scalable apps using React & Flask.",
        "Implemented chatbot integrations with LangChain.",
        "Worked in agile microservice-based teams."
      ]
    }
  ];

  const roles = tab === "education" ? education : experience;
  const current = selectedRole ?? roles[0];

  return (
    <section className="qualification section" id="qualification">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My Journey</span>

      {/* ---- TABS ---- */}
      <div className="qual__tabs">
        <button
          className={tab === "education" ? "tab active" : "tab"}
          onClick={() => {
            setTab("education");
            setSelectedRole(null); // reset selection
          }}
        >
          Education
        </button>

        <button
          className={tab === "experience" ? "tab active" : "tab"}
          onClick={() => {
            setTab("experience");
            setSelectedRole(null); // reset selection
          }}
        >
          Experience
        </button>
      </div>

      {/* ---- MAIN 2-COLUMN LAYOUT ---- */}
      <div className="qual__content">

        {/* LEFT SIDE – TIMELINE SIDEBAR */}
        <div className="qual__sidebar">
          <div className="timeline">
            {roles.map((item) => (
              <div
                key={item.key}
                className={current.key === item.key ? "role-card active" : "role-card"}
                onClick={() => {
                  setSelectedRole(item);
                  setTab(item.category); // highlight correct tab
                }}
              >
                <span className="timeline-dot"></span>
                <div className="role-info">
                  <h4>{item.title}</h4>
                  <span className="small-text">{item.place}</span>
                  <span className="date-text">{item.duration}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE – DETAILS */}
        <div className="qual__details">
          <h2 className="details-title">{current.title}</h2>
          <h3 className="details-sub">{current.place}</h3>
          <div className="details-date">{current.duration}</div>

          <hr />

          <h4 className="details-section-title">Key Achievements</h4>
          <ul className="details-list">
            {current.description.map((p, i) => (
              <li key={i}>{p}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
